<template>
  <div>
    <p>1.非候选单位在中标结果公告后，系统在5日内自动退款。</p>
    <p>2.候选单位：1）若招标方设置候选单位保证金 <span class="text-success">需要</span> 同意退款，则中标结果公告后，需招标方先同意退款，系统才会在同意退款后的5日内自动退款。2）若招标方设置保证金 <span class="text-danger">不需要</span> 同意退款，则中标结果公告后系统在5日内自动退款。</p>
    <p>3.流标后，所有单位保证金当日自动退款。</p>
  </div>
</template>

<script>
export default {
  name: 'BidBondRefundRuleCopywriter'
}
</script>

<style lang="scss" scoped></style>
